import { Box, Tab, Tabs, Paper, Stack, useTheme, useMediaQuery } from "@mui/material";
import React from "react";
import HomeIcon from "../../../GlobalComponents/IconComponents/HomeIcon";
import ChatComponent from "../../../GlobalComponents/Chat/ChatComponent";
import TicketDetailsTab from "./tabs/TicketDetailsTab/TicketDetailsTab";
import AttachmentListTab from "./tabs/AttachmentListTab/AttachmentListTab";
import EscaladeTab from "./tabs/EscaladeTab/EscaladeTab";
import AttachementCounter from "../../../Pages/SAV/Attachements/AttachementCounter";
import TabContainer from "../../../GlobalComponents/TabsContainer/TabContainer";
import NotesList from "../../../Pages/SAV/NotesInternes/NotesList";

export default function EditSAVTicketTabs({
  value,
  onChangeTab,
  ticketDetails,
  formRef,
  setTicket,
  setDirty,
  onCheckRequiredFields,
  nbreAttachementsNonLus,
  fetchAttachments,
  setAttachmentList,
  attachmentList,
  isEscaladed,
  activeInternalStatus,
  onEscaladeRefresh,
  enCours,
  openChatBox,
  setOpenChatBox,
  fetchMessages,
  paginationModelCustom,
  messagesList,
  setMessagesList,
  pageTitle,
  nbreMessagesNonLus,
  setNbreMessagesNonLus,
  viewOnly,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const tabs = [
    {
      id: 1,
      label: 'Ticket',
      icon: <HomeIcon />,
      disabled: false,
      component: (
        <TicketDetailsTab
          ticket={ticketDetails}
          formRef={formRef}
          setTicket={setTicket}
          setDirty={setDirty}
          onCheckRequiredFields={onCheckRequiredFields}
          viewOnly={viewOnly}
        />
      ),
    },
    {
      id: 2,
      label: 'Attachements',
      disabled: false,
      badge:
        nbreAttachementsNonLus > 0 ? (
          <AttachementCounter nbreAttachementsNonLus={nbreAttachementsNonLus} />
        ) : null,
      component: (
        <AttachmentListTab
          idTicket={ticketDetails?.id}
          nbreAttachementsNonLus={nbreAttachementsNonLus}
          fetchAttachments={fetchAttachments}
          setAttachmentList={setAttachmentList}
          attachmentList={attachmentList}
        />
      ),
    },
    {
      id: 3,
      label: 'Escalade',
      disabled: false,
      badge: isEscaladed ? (
        <Box
          component="span"
          sx={{
            ml: 0.75,
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: '#2A66C6',
            display: 'inline-block',
            verticalAlign: 'middle',
            animation: 'pulse 2s infinite',
            '@keyframes pulse': {
              '0%, 100%': { opacity: 1 },
              '50%': { opacity: 0.6 },
            },
          }}
        />
      ) : null,
      component: (
        <EscaladeTab
          ticketId={ticketDetails?.id}
          internalStatus={ticketDetails?.internalStatus ?? []}
          activeInternalStatus={activeInternalStatus}
          isEscaladed={isEscaladed}
          onRefresh={onEscaladeRefresh}
          enCours={enCours}
        />
      ),
    },
    // NOTE INTERN
      {
        id: 4,
        label: 'Notes Internes',
        disabled: false,
        component: (
          <NotesList notes={ticketDetails?.notesInternes ?? []}  />
        ),
      },
      
  ];

  const renderChat = () => (
    <ChatComponent
      open={openChatBox}
      setOpen={setOpenChatBox}
      fetchMessages={fetchMessages}
      fetchAttachments={fetchAttachments}
      paginationModelCustom={paginationModelCustom}
      messagesList={messagesList}
      setMessagesList={setMessagesList}
      openTicket={ticketDetails?.id}
      pageTitle={pageTitle}
      nbreMessagesNonLus={nbreMessagesNonLus}
      setNbreMessagesNonLus={setNbreMessagesNonLus}
    />
  );

  return (
    <Box
      sx={{
        backgroundColor: '#f9fafb',
        height: '80vh',
        width: '100%',
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        p: isMobile ? 1 : 1.25,
        gap: 1.25,
        overflow: 'hidden',
      }}
    >
      {/* Header row: Tabs + Chat */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: '12px 12px 0 0',
          border: '1px solid #e5e7eb',
          borderBottom: 'none',
          backgroundColor: '#ffffff',
          flexShrink: 0,
          width: '100%',
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
          }}
        >
          {/* width: 0 + flex: 1 1 0 = the key trick that makes scrollable tabs actually scroll */}
          <Box
            sx={{
              flex: '1 1 0',
              width: 0,
              minWidth: 0,
              overflow: 'hidden',
            }}
          >
            <Tabs
              value={value}
              onChange={onChangeTab}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                width: '100%',
                minHeight: '48px',
                '& .MuiTabs-scroller': {
                  overflow: 'auto !important',
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: '#2A66C6',
                  height: 3,
                },
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontFamily: 'DM Sans',
                  fontWeight: 500,
                  fontSize: '0.95rem',
                  color: '#6b7280',
                  transition: 'all 0.2s ease',
                  minHeight: '48px',
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                  '&:hover': {
                    color: '#2A66C6',
                    backgroundColor: '#f3f4f6',
                  },
                },
                '& .MuiTab-root.Mui-selected': {
                  color: '#2A66C6',
                  fontWeight: 600,
                },
              }}
            >
              {tabs.map((tab) => (
                <Tab
                  key={tab.id}
                  value={tab.id}
                  disabled={tab.disabled}
                  icon={tab.id === 1 ? tab.icon : undefined}
                  iconPosition={tab.id === 1 ? 'start' : 'end'}
                  label={
                    <Stack direction="row" alignItems="center" spacing={0.75}>
                      <span>{tab.label}</span>
                      {tab.badge && tab.badge}
                    </Stack>
                  }
                />
              ))}
            </Tabs>
          </Box>

          <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center', px: 1 }}>
            {renderChat()}
          </Box>
        </Box>
      </Paper>

      {/* Content area */}
      <Paper
        elevation={0}
        sx={{
          borderRadius: '0 0 12px 12px',
          border: '1px solid #e5e7eb',
          borderTop: 'none',
          flex: 1,
          minHeight: 0,
          width: '100%',
          maxWidth: '100%',
          overflow: 'auto',
          backgroundColor: '#ffffff',
        }}
      >
        {tabs.map((tab) =>
          value === tab.id ? (
            <TabContainer key={tab.id}>{tab.component}</TabContainer>
          ) : null
        )}
      </Paper>
    </Box>
  );
}